import React from "react";
import Image from "next/image";
import Link from "next/link";

import { ArrowRightIcon } from "lucide-react";

import { formatImageUrl } from "@/components/blog/Util";
import { cn } from "@/lib/utils";
import { CaseStudy, HeaderSubheaderComponent } from "@/pages/case-studies/[slug]";
import { clashGrotesk, jakartaSans } from "@/styles/fonts";

const MoreStories = ({ caseStudies }: { caseStudies: CaseStudy[] }) => {
  return (
    <section className={cn("px-4 py-12 md:py-24 bg-ash-100", jakartaSans.variable, clashGrotesk.variable)}>
      <div className="max-w-6xl bg-ash-100 w-full flex flex-col gap-12 md:gap-24 items-center justify-center mx-auto">
        <h2
          className="font-clash text-center font-medium text-4xl md:text-6xl leading-[0.95] tracking-snug relative text-ash-900"
          itemProp="headline"
        >
          Other success stories
        </h2>
        <div className="flex flex-wrap gap-4 justify-center">
          {caseStudies.map((caseStudy: CaseStudy) => (
            <React.Fragment key={caseStudy.slug}>
              <Link href={`/case-studies/${caseStudy.slug}`} className="group">
                <div className="bg-white rounded-3xl flex flex-col justify-between  gap-6 max-w-md pb-8 h-full">
                  <div className="flex flex-col gap-5">
                    <div className="relative rounded-3xl overflow-hidden">
                      <Image
                        src={
                          formatImageUrl(
                            caseStudy.heroImage?.fields.file.url ||
                              caseStudy.testimonialCtaImage?.fields.file.url ||
                              caseStudy.whatsWorkingImage?.fields.file.url ||
                              ""
                          ) || "/rebolt-branding/rebolt-app-icon.png"
                        }
                        alt={caseStudy.title}
                        width={200}
                        height={200}
                        sizes="(max-width: 768px) 90vw, 45vw"
                        className="rounded-3xl w-full object-cover group-hover:scale-105 transition-all duration-300 h-96"
                        loading="eager"
                        priority
                      />
                      <div className="absolute top-0 left-0 right-0 bottom-0 bg-linear-to-t from-ash-900/80 to-ash-900/0 rounded-3xl flex flex-col items-start justify-end p-6">
                        <p className="text-white font-clash font-medium text-lg">{caseStudy.ownerName}&apos;s story</p>
                      </div>
                    </div>
                    <h3 className="font-clash font-medium text-2xl tracking-snug relative px-6">{caseStudy.title}</h3>
                  </div>
                  <div className="px-6 flex flex-col gap-4">
                    <div className="pb-4 border-b border-ash-200 flex flex-col gap-8">
                      <div className="flex flex-row flex-wrap gap-5">
                        {caseStudy.generalReboltStat.map((stat: HeaderSubheaderComponent, index: number) => (
                          <div key={index} className="flex flex-col">
                            <p className="text-lg font-clash font-semibold text-ash-900">{stat.fields.header}</p>
                            <p className="text-sm text-ash-700">{stat.fields.subheader}</p>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="flex flex-row items-center gap-2">
                      <p className="text-md font-medium text-rebolt-500">Read full story</p>
                      <ArrowRightIcon className="w-4 h-4 text-rebolt-500 " />
                    </div>
                  </div>
                </div>
              </Link>
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MoreStories;
